import moment from 'moment';
import { trackingEvent } from '../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../analytics/utils';
import { getEndDateByGantt } from '../../../../utils/lookahead-common';
import {
  findDeepGetTask,
  updateAsyncTaskGanttV2,
  updateTaskDragHelperHack
} from '../../GanttVisualization.helper';

export const formatDate = (date, gantt) => {
  const format =
    gantt?.currentDateFormat?.replace('hh', 'HH') || 'YYYY-MM-DD HH:mm';
  return moment(date).format(format);
};

export const onChangeStart = (task, gantt, date) => {
  const taskFromLookahead = findDeepGetTask(window.activities, 'id', task.id);
  if (!taskFromLookahead) return null;

  gantt.updateCustomCommitmentPercentaje(taskFromLookahead, false);

  taskFromLookahead.start_date = date;
  getEndDateByGantt(taskFromLookahead, task.activityReference);

  const fieldsToUpdate = ['start_date', 'duration', 'end_date'];
  updateAsyncTaskGanttV2(taskFromLookahead, fieldsToUpdate, null, gantt);

  trackingEvent(
    'task_start_date_edition',
    {
      ...getBasicAmplitudEventProperties(),
      task_id: taskFromLookahead?.id,
      task_name: taskFromLookahead?.name,
      parent_activity_name: task.activityReference?.name,
      parent_activity_id: task.activityReference?.id
    },
    AMPLITUDE_SERVICE
  );

  /** update other fields */
  updateTaskDragHelperHack(task.id, task);
};
